import { render, staticRenderFns } from "./Activitys.vue?vue&type=template&id=143622d4"
import script from "./Activitys.vue?vue&type=script&lang=js"
export * from "./Activitys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports